import { createReducer, on } from '@ngrx/store';
import { ApplicationsApiActions } from './vpp-applications.actions';
import { adapter, initialState } from './vpp-applications.state';

export const VppApplicationsReducer = createReducer(
  initialState,
  on(ApplicationsApiActions.vppApplicationsLoaded, (state, { applications }) => adapter.setAll(applications, state))
);

const { selectIds, selectEntities, selectAll } = adapter.getSelectors();

export const selectVppApplicationIds = selectIds;

export const selectVppApplicationEntities = selectEntities;

export const selectAllVppApplications = selectAll;
